import {FilesList} from 'quickstart/components/content/FilesList'
import {useApi} from 'quickstart/hooks'
import {partitionMetaProps} from 'quickstart/utils'
import * as R from 'rambdax'
import {forwardRef} from 'react'

const isVisible = R.pathOr(true, ['props', 'isVisible'])
const includeDirectly = R.pathOr(false, ['props', 'includeDirectly'])

export const useAttachmentsList = (props, ref) => {
  const [
    metaProps,
    {excludedSources = [], filterByUserLicenses = false, ...rest},
  ] = partitionMetaProps(props)
  const {metaObj, tizraId = metaObj?.tizraId} = metaProps

  const notExcluded = x => !excludedSources.includes(x.sourceName)

  const pred = R.allPass([
    isVisible,
    R.complement(includeDirectly),
    notExcluded,
  ])

  const attachments = useApi
    .attachments(
      tizraId && {
        tizraId,
        filterLicenses: filterByUserLicenses,
      },
    )
    .data?.result?.filter(pred)

  if (!attachments?.length) {
    return null
  }

  return <FilesList ref={ref} items={attachments} {...rest} />
}

export const AttachmentsList = forwardRef(
  ({children, render = children, ...rest}, ref) => {
    const content = useAttachmentsList(rest, ref)
    return render ? render(content) : content
  },
)
